enum Roles {
  ADMIN = "ADMIN",
  USER = "USER",
  P1 = "P1 (Gestionnaire de relations)",
  P2 = "P2 (Responsable données)",
  P3 = "P3 (Analyste conformité)",
  P4 = "P4 (Responsable Conformité)",
  /** Persona editeur (Box Africa) : parametres plateforme reserves, hors perimetre metier BNI. */
  BOX_AFRICA_ADMIN = "BOX_AFRICA_ADMIN",
}

export default Roles;
